import { alertClient } from './api-grpc';
import { GetAlertListByPageResponse } from '../gen/proto/api/gateway/v1/alert_pb';

export const alertApi = {
  async getAlertByPagination(pageIndex: number, pageSize: number): Promise<GetAlertListByPageResponse> {
    const response = await alertClient.getAlertListByPage({
      pagination: {
        pageIndex,
        pageSize,
      },
    });
    if (!response) {
      throw new Error('Alarms table could not be loaded.');
    }
    return response;
  },
};
